import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import toast from 'react-hot-toast';

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

/**
 * Carrito de la sección mayorista (la tienda minorista es solo catálogo).
 * Por ahora sin cupones ni envío: el pedido se registra y se coordina por fuera.
 */
export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('msf_cart')) || [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('msf_cart', JSON.stringify(items));
  }, [items]);

  const keyOf = (it) => `${it.product}-${it.variantId || ''}`;

  const addItem = (product, { quantity = 1, variant = null } = {}) => {
    setItems((prev) => {
      const newItem = {
        product: product._id,
        slug: product.slug,
        name: product.name,
        // la foto de la variante es la que identifica el color
        image: variant?.image || product.images?.[0] || '',
        variantId: variant?._id || null,
        sku: variant?.sku || '',
        price: variant?.price || product.price,
        quantity,
        color: variant?.color || '',
        size: variant?.size || '',
      };
      const idx = prev.findIndex((i) => keyOf(i) === keyOf(newItem));
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        return copy;
      }
      return [...prev, newItem];
    });
    toast.success('Agregado al pedido');
    setIsOpen(true);
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => keyOf(i) !== key));

  const updateQty = (key, qty) =>
    setItems((prev) => prev.map((i) => (keyOf(i) === key ? { ...i, quantity: Math.max(1, qty) } : i)));

  const clearCart = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartContext.Provider
      value={{ items, count, subtotal, total: subtotal, addItem, removeItem, updateQty, clearCart, keyOf, isOpen, setIsOpen }}
    >
      {children}
    </CartContext.Provider>
  );
}
